export enum DemandBulkActionImportType {
    ProductUpdate = "PRODUCT_UPDATE",
    VariantUpdate = "VARIANT_UPDATE",
}
